
export function businessHours() {
  return {
    'restrict': 'E',
    'template': require('./business-hours.directive.html'),
    'scope': {
      'model': '=',
      'enableSaveFn': '&enableSave'
    },
    'controller': controller
  };
}

export function bhDateToYearMonthDay(d) {
  return d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
}

export function dateFromBhDateString(dateString) {
  const dateParts = dateString.split('-');
  return new Date(parseInt(dateParts[0]), parseInt(dateParts[1])-1, parseInt(dateParts[2]));
}

controller.$inject = ['$scope', '$mdDialog', '$translate', 'BusinessHoursFactory', 'DropdownItemsFactory'];
function controller($scope, $mdDialog, $translate, BusinessHoursFactory, DropdownItemsFactory) {

  $scope.addWeekDay = addWeekDay;
  $scope.deleteWeekDay = deleteWeekDay;
  $scope.editWeekDay = editWeekDay;

  $scope.addException = addException;
  $scope.deleteException = deleteException;
  $scope.editException = editException;

  $scope.formatTime = formatTime;
  $scope.dateFromBhDateString = dateFromBhDateString;

  init();

  function padLeading(i) {
    return ('000' + i).slice(-2);
  }

  function formatTime(t) {
    return padLeading(t.h) + ':' + padLeading(t.m);
  };


  function enableSave() {
    $scope.enableSaveFn();
  }
  
  function addException() {
    $scope.model.exceptions.push({
      date : bhDateToYearMonthDay(new Date()),
      start: { h: 8, m: 0},
      end : { h : 18, m: 0}
    });
    enableSave();
  };
  
  function deleteException(index) {
    $scope.model.exceptions.splice(index, 1);
    enableSave();
  }
  
  function editException(index, exception, event) {
    enableSave();
    $mdDialog.show({
      'controller': 'ExceptionEditionController',
      'template': require('./exception-edition.dialog.html'),
      'targetEvent': event,
      'locals': {
        'exception': angular.copy(exception)
      }
    })
    .then(function(modifiedException) {
      // copy properties instead of outer object to avoid animation glitch with ng-repeat
      $scope.model.exceptions[index].date = modifiedException.date;
      $scope.model.exceptions[index].start = modifiedException.start;
      $scope.model.exceptions[index].end = modifiedException.end;
    });
  }
  
  function addWeekDay() {
    $scope.model.week.push({
      id : 0,
      start: { h: 8, m: 0},
      end : { h : 18, m: 0}
    });
    enableSave();
  };

  function deleteWeekDay(index) {
    $scope.model.week.splice(index, 1);
    enableSave();
  };

  function editWeekDay(index, day) {
    enableSave();
    $mdDialog.show({
      'controller': 'WeekDayEditionController',
      'template': require('./week-day-edition.dialog.html'),
      'targetEvent': event,
      'multiple': true,
      'locals': {
        'day': angular.copy(day)
      }
    })
    .then(function(modifiedDay) {
      // copy properties instead of outer object to avoid animation glitch with ng-repeat
      $scope.model.week[index].id = modifiedDay.id;
      $scope.model.week[index].start = modifiedDay.start;
      $scope.model.week[index].end = modifiedDay.end;
    });
  }

  function init() {
    $scope.daysOfWeek = BusinessHoursFactory.daysOfWeek();
    $scope.timezoneItems = DropdownItemsFactory.buildTimezoneItems();
  
  }

}
